<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="720px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div class="container-dialog">
      <div class="left">
        <i style="font-size: 68px;color: #0090ff;" class="el-icon-warning"></i>
      </div>
      <div class="right">
        <div>操作提醒</div>
        <div class="content">
          当前选择事项名称不唯一，请选择某一固定事项再进行批量配置
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">我知道了</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none !important;
  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
  padding-top: 0;
}
.container-dialog {
  padding: 0 24px;
  display: flex;
  .left {
    width: 57px;
    height: 57px;
    margin-right: 16px;
  }
  .right {
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 24px;
    color: #494c4f;
    .content {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 18px;
      color: #494c4f;
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointEvent/components/tipDialog.vue